// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1SlhR","notes":"Notes_notes__2jYRQ","note":"Notes_note__29V-m","markdown":"Notes_markdown__3Ssd1"};